export default {
  'app.member': '成員權限',
  'app.member.management': '成員管理',
  'app.member.management.search': '搜尋篩選',
  'app.member.management.invite': '邀請團隊成員',
  'app.member.management.invite.sso.tip':
    '該組織已啟用 SSO 登入，未曾授予過角色的成員將自動Default 角色。您可以在成員加入後修改他的角色。',
  'app.member.management.invite.edit': '編輯成員',
  'app.member.management.invite.name.first': '名稱',
  'app.member.management.invite.name.first.placeholder': `輸入受邀者的名稱`,
  'app.member.management.invite.name.first.validate': `請輸入受邀者的名稱`,
  'app.member.management.invite.name.last': '姓氏',
  'app.member.management.invite.name.last.placeholder': `輸入受邀者的姓氏`,
  'app.member.management.invite.name.last.validate': `請輸入受邀者的姓氏`,
  'app.member.management.invite.email': '電子郵件',
  'app.member.management.invite.email.placeholder': `輸入受邀者的電子郵件`,
  'app.member.management.invite.email.validate.empty': `請輸入受邀者的電子郵件`,
  'app.member.management.invite.email.validate.right': '請輸入有效的電子郵件',
  'app.member.management.invite.ssoConfig': '組織 SSO 服務',
  'app.member.management.invite.ssoConfig.placeholder': '選擇該組織的 SSO 服務',
  'app.member.management.invite.ssoConfig.validate': '請選擇該組織的 SSO 服務',
  'app.member.management.invite.role': '角色',
  'app.member.management.invite.role.placeholder': '選擇一個該組織的角色',
  'app.member.management.invite.role.empty': '暫無任何角色',
  'app.member.management.invite.role.create': '去新增角色',
  'app.member.management.invite.role.validate': '請選擇一個該組織的角色',
  'app.member.management.invite.ok': '確認',
  'app.member.management.invite.cancel': '取消',
  'app.member.management.table.name': '帳戶名稱',
  'app.member.management.table.id': '帳戶ID',
  'app.member.management.table.status': '帳號狀態',
  'app.member.management.table.status.enable': '啟用',
  'app.member.management.table.status.disable': '停用',
  'app.member.management.table.status.wait': '待加入',
  'app.member.management.table.time.last': '最後存取時間',
  'app.member.management.table.time.create': '建立時間',
  'app.member.management.table.operation': '操作',
  'app.member.management.table.operation.detail': '详情',
  'app.member.management.table.operation.edit': '編輯',
  'app.member.management.table.operation.resend': '重發邀請',
  'app.member.management.table.operation.disable': '停用',
  'app.member.management.table.operation.enable': '啟用',
  'app.member.management.table.operation.delete': '刪除',
  'app.member.management.table.operation.delete.confirm': '刪除後帳戶不可用',
  'app.member.management.table.operation.delete.confirm.ok': '確認',
  'app.member.management.table.operation.delete.confirm.cancel': '取消',
  'app.member.management.table.operation.invite.success': '邀請成功',
  'app.member.role': '角色管理',
  'app.member.role.create': '建立角色',
  'app.member.role.edit': '修改角色',
  'app.member.role.creater.validate': '請輸入角色名稱',
  'app.member.role.create.placeholder': `輸入角色名稱`,
  'app.member.role.admin': '管理員',
  'app.member.role.rights': '權限明細',
  'app.member.role.members': '角色成員',
  'app.member.role.name.placeholder': '輸入角色名稱、該名稱已被使用',
  'app.member.role.creater': '建立者',
  'app.member.role.console': '控制台',
  'app.member.role.empty': '暫未創建應用',
  'app.member.role.tip': '全域角色預設為每項專案的預先設定角色',
  'app.member.role.submit': '設定已成功！',
  'app.member.role.save': '保存成功！',
  'app.member.role.delete': '刪除角色後，該角色下關聯的成員權限將失效',
  'app.member.role.delete.ok': '刪除',
  'app.member.role.delete.cancel': '取消',
  'app.member.role.members.table.search': '搜尋篩選',
  'app.member.role.members.table.name': '帳戶名稱',
  'app.member.role.members.table.id': '帳戶ID',
  'app.member.role.members.table.emial': '電子郵件',
  'app.member.role.members.table.status': '帳號狀態',
  'app.member.role.members.table.status.enable': '啟用',
  'app.member.role.members.table.status.disable': '停用',
  'app.member.role.members.table.status.wait': '待加入',
  'app.member.role.members.table.time.last': '最後存取時間',
  'app.member.role.members.table.time.create': '建立時間',
  'app.member.role.members.table.operation': '操作',
  'app.member.role.members.table.operation.detail': '详情',
  'app.member.role.members.table.operation.detail.title': '成員详情',
  'app.member.role.members.table.operation.detail.permission': '權限详情',
  'app.member.role.members.table.operation.delete': '移除角色',
  'app.member.role.permission.sharing': '所有應用共用角色許可權',
  'app.member.role.permission.sharing.tip':
    '勾選之後再保存，該角色所具備的許可權，在所有應用中均保持一致。',
  'app.member.management.create.org': '是否允許成員創建組織',
  'app.member.management.create.yes': '是',
  'app.member.management.create.no': '否',
  'app.member.roleCopy.copy': '複製角色',
  'app.member.roleCopy.title': '複製角色到其它組織',
  'app.member.roleCopy.select': '選擇組織',
  'app.member.roleCopy.selectTip': '請選擇組織',
  'app.member.roleCopy.all': '全選',
  'app.member.roleCopy.success': '複製成功！',
  'app.member.role.otp.target.tip': `<p>1）目標為手機號碼時：</p>
    <p>當運營人員無查看目標的權限時，打開歷史記錄時，看到的號碼已被脫敏，脫敏後僅展示號碼字符串的前3位字符與後2位字符。</p>
    <p>2）目標為郵箱時：</p>
    <p>僅展示前2位字符，{'@'}後的郵件地址部分保持不變。</p>
    <p>比如：</p>
    <p>otpsupport{'@'}engagelab.com</p>
    <p>脫敏後，展示為：</p>
    <p>ot***{'@'}engagelab.com</p>
    `,
};
